import angular from 'angular';

import ImageComponent from './image.cmpt';

export default angular.module('common.image', [])
    .component(ImageComponent.selector, ImageComponent);



// WEBPACK FOOTER //
// ./src/common/component/image/index.js